{
  "production": {
    "apiUrl": "https://api.tellent.com",
    "serverApiUrl": "http://api-service.default.svc.cluster.local:4000",
    "baseUrl": "https://updates.tellent.com"
  },
  "rc": {
    "apiUrl": "https://api.rc.tellent.com",
    "serverApiUrl": "http://api-service.default.svc.cluster.local:4000",
    "baseUrl": "https://updates.rc.tellent.com"
  },
  "staging": {
    "apiUrl": "https://api.s.tellent.com",
    "serverApiUrl": "http://api-service.default.svc.cluster.local:4000",
    "baseUrl": "https://updates.s.tellent.com"
  },
  "local-staging": {
    "apiUrl": "https://api.s.tellent.com",
    "serverApiUrl": "https://api.s.tellent.com",
    "baseUrl": "https://updates.tellent.internal"
  },
  "local-production": {
    "apiUrl": "https://api.tellent.com",
    "serverApiUrl": "https://api.tellent.com",
    "baseUrl": "https://updates.tellent.internal"
  },
  "local-rc": {
    "apiUrl": "https://api.rc.tellent.com",
    "serverApiUrl": "https://api.rc.tellent.com",
    "baseUrl": "https://updates.rc.tellent.internal"
  }
}
